// @flow
import React from "react";
import DefaultLogo from "../assets/placeholderLogo.png";
import i18n from "../../i18n";

class Logo extends React.Component {
  static defaultProps = {
    logoURI: DefaultLogo,
    logoLink: "https://www.storedvalue.com/en-US/home",
    logoClassNames: "formatLogo"
  };

  render() {
    const { logoURI, logoLink, logoClassNames, logoImgAlt, customNS } = this.props;
    return (
      <a href={logoLink}>
        <img
          src={logoURI}
          alt={i18n.t(logoImgAlt, {ns: customNS})}
          className={`img-fluid ${logoClassNames || ""}`}
        />
      </a>
    );
  }
}

export default Logo;
